import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { URL_GLOBAL, URL_WS_CHATGERAL } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ChatGeralService {

    // UrlCnab = 'https://madelife.med.br:9025/api/Cnab';
    websocket: any = null;
    reconnect: any = null;
    need_reconnect: boolean = true;
    connecting: boolean = false;

    loading: boolean = true;
    observer: Subject<any> = new Subject<any>();
    socket: any = null;
    dataObservable: Observable<any>;
    constructor(private http: HttpClient) {
        this.dataObservable = this.observer.asObservable();
    }


    connect(token: any) {
        if (this.loading == true && this.connecting == false) {
            this.connecting = true;

            // this.socket = new WebSocket('wss://api.madelife.med.br:1123');
            this.socket = new WebSocket(URL_WS_CHATGERAL);
            this.socket.addEventListener('open', (event) => {
                // Deserializamos o objeto
                this.observer.next({ data: JSON.stringify({ type: 'conectou' }) });

                clearTimeout(this.reconnect);
                this.socket.send(JSON.stringify({ type: 'token', token: token.access_token, token_type: token.token_type }));
                this.loading = false;

            });
            this.socket.addEventListener('message', (event) => {
                if (this.observer != undefined) {
                    this.observer.next(event);
                }
            });

            this.socket.addEventListener('close', (event) => {
                // Deserializamos o objeto
                // Escrevemos no DOM
                this.loading = true;
                this.connecting = false

                this.observer.next({ data: JSON.stringify({ type: 'desconectou' }) });
                if (this.need_reconnect == true) {
                    this.reconnect = setTimeout(() => {
                        this.connect(token);
                    }, 2000);
                }


            });
        }
        else if (this.loading == false) {
            this.observer.next({ data: JSON.stringify({ type: 'conectou' }) });

        }
    }





    getConversas(token): Observable<Array<any>> {
        const headers = new HttpHeaders({
            'Authorization': token["token_type"] + " " + token.access_token
        });
        return this.http.get<any[]>(`${URL_GLOBAL}/web/chat/get_conversas`, { headers })
    }

    getPessoas(token, name): Observable<Array<any>> {
        const headers = new HttpHeaders({
            'Authorization': token["token_type"] + " " + token.access_token
        });
        return this.http.get<any[]>(`${URL_GLOBAL}/web/chat/get_pessoas?search=${name}`, { headers })
    }

    enviar_arquivos(data, token): Observable<Array<any>> {
        const headers = new HttpHeaders({
            'Authorization': token["token_type"] + " " + token.access_token
        });
        return this.http.post<any>(`${URL_GLOBAL}/web/chat/enviarArquivos`, data, { headers });
    }
}
